import { useState } from 'react';
import { reviewList } from '@/mocks/homeContent';
import SectionHead from './SectionHead';

export default function Reviews() {
  const [active, setActive] = useState(0);
  const item = reviewList[active];

  return (
    <section id="reviews" className="scroll-mt-24 bg-background-50 py-12 md:py-16">
      <div className="container-x">
        <SectionHead
          eyebrow="编辑部深度实测"
          title="热门搭讪博主深度测评"
          sub="不从「网红」热度出发，只看连续追更后的真实表现。选中左侧博主，展开完整优缺点与适用人群判断。"
        />

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-[300px_1fr]">
          <div className="flex flex-row gap-2 overflow-x-auto lg:flex-col lg:gap-3 lg:overflow-visible">
            {reviewList.map((r, idx) => (
              <button
                key={r.id}
                type="button"
                onClick={() => setActive(idx)}
                className={`flex flex-shrink-0 flex-col gap-2 rounded-2xl border p-4 text-left transition lg:w-full ${
                  active === idx
                    ? 'border-primary-300 bg-primary-50 shadow-soft'
                    : 'border-background-200 bg-background-50 hover:border-background-300'
                }`}
              >
                <div className="flex items-center justify-between">
                  <span className="flex items-center gap-2">
                    <span className={`flex h-8 w-8 items-center justify-center rounded-full ${r.avatarHue} text-sm font-bold text-background-50`}>
                      {r.name.charAt(0)}
                    </span>
                    <span className="font-heading text-base font-bold text-foreground-950">{r.name}</span>
                  </span>
                  <span className="chip bg-background-100 px-2 py-0.5 text-xs text-foreground-600">{r.platform}</span>
                </div>
                <div className="flex flex-wrap items-center gap-1.5">
                  <span className="text-xs text-foreground-500">{r.fans} 粉丝</span>
                  <span className="chip bg-accent-50 px-2 py-0.5 text-xs text-accent-700">{r.badge}</span>
                </div>
              </button>
            ))}
          </div>

          <div className="rounded-2xl border border-background-200 bg-background-50 p-5 shadow-soft md:p-6">
            <div className="flex flex-wrap items-start justify-between gap-4 border-b border-background-200 pb-4">
              <div className="flex flex-col gap-2">
                <div className="flex flex-wrap items-center gap-2">
                  <h3 className="font-heading text-2xl font-bold text-foreground-950">{item.name}</h3>
                  <span className="chip bg-primary-100 text-primary-700">{item.topic}</span>
                  <span className="chip bg-accent-100 text-accent-800">{item.badge}</span>
                </div>
                <p className="max-w-2xl text-sm leading-7 text-foreground-600">{item.tagline}</p>
              </div>
              <div className="flex flex-col items-center rounded-2xl bg-primary-500 px-5 py-3 text-background-50">
                <span className="text-xs opacity-80">综合评分</span>
                <span className="font-heading text-3xl font-black">{item.score}</span>
              </div>
            </div>

            <div className="mt-5 grid grid-cols-1 gap-5 md:grid-cols-2">
              <div className="rounded-2xl bg-accent-50/70 p-4">
                <h4 className="mb-3 flex items-center gap-2 text-sm font-bold text-accent-900">
                  <i className="ri-check-double-line text-lg" aria-hidden="true"></i> 值得看的地方
                </h4>
                <ul className="flex flex-col gap-2">
                  {item.pros.map((p) => (
                    <li key={p} className="flex gap-2 text-sm leading-6 text-foreground-700">
                      <i className="mt-1 text-accent-600 ri-check-line" aria-hidden="true"></i>
                      <span>{p}</span>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="rounded-2xl bg-secondary-100/70 p-4">
                <h4 className="mb-3 flex items-center gap-2 text-sm font-bold text-secondary-900">
                  <i className="ri-error-warning-line text-lg" aria-hidden="true"></i> 需要留意的坑
                </h4>
                <ul className="flex flex-col gap-2">
                  {item.cons.map((c) => (
                    <li key={c} className="flex gap-2 text-sm leading-6 text-foreground-700">
                      <i className="mt-1 text-secondary-700 ri-close-circle-line" aria-hidden="true"></i>
                      <span>{c}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="mt-5 grid grid-cols-1 gap-4 sm:grid-cols-2">
              <div className="rounded-xl bg-background-100 px-4 py-3">
                <h4 className="text-xs font-bold text-foreground-500">适合人群</h4>
                <p className="mt-1 text-sm leading-6 text-foreground-800">{item.suited}</p>
              </div>
              <div className="rounded-xl bg-background-100 px-4 py-3">
                <h4 className="text-xs font-bold text-foreground-500">编辑部结论</h4>
                <p className="mt-1 text-sm font-medium leading-6 text-primary-700">{item.verdict}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}